import { useField } from './useField';
import { useWatchFieldValue } from './useWatchFieldValue';

export const useWatchField: typeof useField = (name, options) => {
    const value = useWatchFieldValue(name);
    const [inputProps, metaProps, helperProps] = useField(name, options);

    return [{ ...inputProps, value }, metaProps, helperProps] as any;
};
